<template>
  <page class="home-page">
    <div class="home-warp">
      <img class="home-logo" src="../../assets/imgs/logo.png" alt="" />
      <h2 class="home-title">Power bank unlocked</h2>
      <p class="home-title-des">Stay charged, Stay Connected!</p>

      <div class="warp-successful">
        <img src="../../assets/imgs/img_lease_successful.png" alt="" />
        Please take power bank
      </div>
      <div class="home-warp-borrow">
        <p class="text">Timer has started</p>
        <p class="text">Return to any Lumra Station</p>
        <div class="btn borrow" @click="goOrder">Support</div>
      </div>
      <div class="home-warp-readme">
        <span @click="onReadMe">Terms of Use</span>
        <span class="readme">Privacy and Cookies</span>
      </div>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex";
import { ORDER_CHECK } from "../../apis/cabinet.js";
import {
  PAYPAL_EXC_PAY,
  PAYPAL_CONFIRM,
  MERCADO_PAYCONFIRM
} from "../../apis/payment.js";
import homeMixin from "../../mixins/home";
let loadingTimer;
export default {
  mixins: [homeMixin],
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    paypal(val, oldVal) {
      if (val && val.paymentId) {
        this.onPayExec();
      }
    }
  },
  computed: {
    ...mapState(["cabinet", "system", "paypalTradeNo", "paymentId"]),
    i18n() {
      return this.$t("result");
    },
    i18nConfirm() {
      return this.$t("confirm");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    percent() {
      return (this.second % 30) * 3.334;
    },
    secondFmt() {
      return (this.second + 0.45).toFixed(0);
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format(this.order);
    },
    infoTips1() {
      return `${this.i18n.tips_1}`.format(this.order);
    },
    infoTips2() {
      return this.i18n.tips_2;
    },
    imgSrc() {
      // if (this.order && this.order.shebei) {
      //   return require(`../../assets/imgs/cabinet${this.order.shebei}_${this.order.number}.gif`)
      // } else {
      return require(`../../assets/imgs/result_main_banner.png`);
      // }
    }
  },
  data() {
    return {
      loading: false,
      error: "",
      paypal: null,
      order: null,
      tradeNo: "",
      second: 0,
      payMode: "paypal"
    };
  },
  methods: {
    onDownload() {
      if (this.system === "ios") {
        this.onAppStore();
      } else {
        this.onGooglePlay();
      }
    },
    onAppStore() {
      console.log("11111");
      if (!process.env.VUE_APP_APP_STORE) {
        this.$toast(this.i18nMsg.appoffline);
        return;
      }
      window.location.href = process.env.VUE_APP_APP_STORE;
    },
    onGooglePlay() {
      console.log("22222");
      if (!process.env.VUE_APP_GOOGLE_PLAY) {
        this.$toast(this.i18nMsg.appoffline);
        return;
      }
      window.location.href = process.env.VUE_APP_GOOGLE_PLAY;
    },
    startTimer() {
      if (this.second === 0) {
        loadingTimer = setInterval(() => {
          this.second += 0.1;
        }, 100);
      }
    },
    stopTimer() {
      clearInterval(loadingTimer);
      this.second = 0;
    },
    onInput(val) {
      this.$emit("input", val);
    },
    goOrder() {
      this.$router.replace("/order");
    },
    onReload() {
      if (this.tradeNo) {
        this.checkOrder(this.tradeNo, this.payMode);
      } else {
        this.onPayExec();
      }
    },
    onPayExec() {
      this.startTimer();
      this.loading = true;
      this.$post(
        PAYPAL_EXC_PAY,
        {
          ...this.paypal
        },
        resp => {
          this.loading = false;
          this.error = "";
          const data = resp.data;
          if (data.out_trade_no) {
            if (data.pay_type === "CZ") {
              this.$confirm({
                title: this.i18nMsg.title,
                content: this.i18nMsg.success_payment,
                confirmText: this.i18nMsg.confirm,
                showCancel: false
              }).then(() => {
                this.$router.push("/mine");
              });
            }
            if (data.pay_type === "YJ") {
              this.checkOrder(data.out_trade_no);
            }
          }
        },
        error => {
          if (this.second < 30) {
            this.onPayExec();
          } else {
            this.stopTimer();
            this.loading = false;
            this.error = error;
            console.log(error);
          }
        }
      );
    },
    checkOrder(tradeNo, payMode = "paypal", payType = "") {
      if (!payType) {
        this.startTimer();
      }
      // if (payMode === 'mpesa') {
      //   this.onSMSCheckOrder(tradeNo, payMode, payType)
      //   return
      // }
      this.tradeNo = tradeNo;
      this.loading = true;
      this.$post(
        `${ORDER_CHECK}/${tradeNo}/${payMode}`,
        {},
        resp => {
          if (payType === "FK") {
            this.$router.replace({ path: "/order" });
          } else if (payType === "CZ") {
            this.$router.replace({ path: "/wallet" });
          }
          this.loading = false;
          this.error = "";
          this.stopTimer();
          this.order = resp;
        },
        error => {
          if (payType === "FK") {
            setTimeout(() => {
              this.$router.replace({ path: "/order" });
            }, 1500);
          } else if (payType === "CZ") {
            setTimeout(() => {
              this.$router.replace({ path: "/wallet" });
            }, 1500);
          } else if (
            error === "正在请求中" ||
            error === "Processing" ||
            error === "正在請求中"
          ) {
            setTimeout(() => {
              this.checkOrder(tradeNo, payMode, payType);
            }, 1000);
          } else {
            this.stopTimer();
            this.loading = false;
            this.error = error;
            console.log(error);
          }
        }
      );
    },
    onPaypalConfirm(tradeNo) {
      this.startTimer();
      this.loading = true;
      let url = PAYPAL_CONFIRM;
      this.$post(
        url,
        {
          tradeNo: tradeNo,
          paymentId: this.paymentId
        },
        resp => {
          this.loading = false;
          this.error = "";
          this.stopTimer();
          this.order = resp;
        },
        error => {
          if (error === "正在请求中" || error === "Processing") {
            setTimeout(() => {
              this.onPaypalConfirm(tradeNo);
            }, 1000);
          } else {
            this.stopTimer();
            this.loading = false;
            this.error = error;
            console.log(error);
          }
        }
      );
    },
    mercaDoPaGoConfirm(orderId) {
      let url = MERCADO_PAYCONFIRM;
      this.$loading(true);
      this.$get(
        url,
        {
          outTradeNo: orderId
        },
        resp => {
          this.$loading(false);
          console.log("mercaDoPaGo确认数据===", resp);
          if (resp.data) {
            this.checkOrder(orderId, "mercaDoPaGo", "");
          }
        },
        error => {
          this.$loading(false);
          this.$confirm({
            title: this.i18nConfirm.msg_fail_title,
            content: error,
            confirmText: this.i18nConfirm.msg_fail_retry,
            cancelText: this.i18nConfirm.msg_fail_cancel
          }).then(() => {
            this.mercaDoPaGoConfirm(orderId);
          });
          console.log(error);
        }
      );
    }
  },
  created() {
    console.log("result route:", this.$route.query);
    let {
      paymentId,
      token,
      PayerID,
      tradeNo,
      payMode,
      payType,
      outTradeNo
    } = this.$route.query;
    this.payMode = payMode;
    if (this.paypalTradeNo) {
      this.onPaypalConfirm(this.paypalTradeNo);
    } else if (tradeNo) {
      this.checkOrder(tradeNo, payMode, payType);
    } else if (outTradeNo) {
      this.mercaDoPaGoConfirm(outTradeNo);
    } else {
      this.paypal = {
        paymentId,
        token,
        payerId: PayerID
      };
    }
  },
  beforeDestroy() {
    this.$store.commit("paypalTradeNo", null);
  },
  destroyed() {
    this.$store.commit("cabinet", null);
  }
};
</script>

<style lang="less">
.home-page {
  height: 100vh;
  overflow: hidden;
  background-color: #fafe45;
}

.home-warp {
  height: 100vh;
  overflow-x: auto;
  .home-logo {
    display: block;
    width: 320px;
    margin: 109px auto 35px;
  }
  .home-title {
    font-size: 50px;
    text-align: center;
    &-des {
      font-size: 28px;
      font-weight: bold;
      text-align: center;
    }
  }
  .warp-successful {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    font-size: 28px;
    color: #000;
    font-weight: bold;
    img {
      width: 42%;
      margin-bottom: 20px;
    }
  }

  &-borrow {
    margin: 90px 80px 0;
    .text {
      margin: 0 30px 0 60px;
      font-size: 24px;
      color: #000;
    }
    .borrow {
      height: 123px;
      line-height: 123px;
      border-radius: 66px;
      margin: 30px 0 60px;
      color: #000;
      font-size: 46px;
      font-weight: bold;
      background-color: #fff;
    }
  }

  &-readme {
    display: block;
    color: #000;
    font-size: 24px;
    text-align: center;
    text-decoration: underline;
    .readme {
      margin-left: 20px;
    }
  }
}
</style>
